import Component from '$store/components/header/Buttons/Cart/vtex.tsx'

function Island({ isMinicart, size }: { isMinicart?: boolean; size?: 'md' | 'lg' }) {
    return <Component isMinicart={isMinicart} size={size} />
}

export default Island
